<template>
  <ul class="prd-list">
    <template v-for="algorithm in algorithms" v-bind:key="algorithm">
      <AlgorithmCard
          :title="algorithm.title"
          :sub-title="algorithm.subTitle"
          :code="algorithm.code"
          :user-count="algorithm.userCount"
          :tags="algorithm.cardTags"
      ></AlgorithmCard>
    </template>
  </ul>
</template>

<script>
import AlgorithmCard from "../components/AlgorithmCard";
import apiClient from "../../utils/instance";

export default {
  name: "AlgorithmList",
  components: {
    AlgorithmCard
  },
  data() {
    return {
      algorithms: []
    }
  },
  async mounted() {
    this.algorithms = (await apiClient.instance.get('/products?category=ALGORITHM')).data;
  }
}
</script>

<style scoped>

</style>
